export const AppStrings = {
  BUTTON: {
    YES: "Yes",
    NO: "No",
    SUBMIT: "Submit"
  },
  GENERIC_ERROR: "Something went wrong. please try again later",
  CANCELTRANSACTION: {
    TITLE: "Cancel Transaction",
    DESCRIPTION: "Are you sure you want to cancel the transaction?"
  },
  LOAN_DISBURSEMENT: {
    HEADER: "Loan Confirmation",
    TITLE: "Do you have a valid education loan disbursement letter?",
    DESCRIPTION: "If yes, your TCS will be 0%. You will be asked to upload a digital copy of the loan disbursement letter."
  },
  PREVIEW_DOCS: {
    DOCUMENTS_PREVIEW: "Documents Preview",
  },
  AMOUNT_SECTION: {
    HEADING: "Amount",
    YOU_SEND_LABEL: "You Send",
    THEY_RECEIVE_LABEL: "They Receive",
    PURPOSE_CODE_LABEL: "Purpose Code",
    EXCHANGE_RATE_LABEL: "Exchange Rate",
    SELECT_PURPOSE: "Select purpose",
    VENDOR_CODE_LABEL: "Vendor Name/Code",
    LESS_AMOUNT_WARNING: "User may receive the lesser amount due to the beneficiary bank charges.",
    SELECT_PURPOSE_TO_ENABLE_RATE: "Please select the purpose code  to edit the exchange rate"
  },
  CALCULATION_SECTION: {
    HEADING: "Calculation",
    YOU_SEND: "You Send",
    EXCHANGE_RATE: "Exchange rate",
    TAXES_AND_FEES: "Taxes and fees",
    GST: "GST",
    BANK_FEE: "Bank Fee",
    BANK_AND_CONVENIENCE_FEE: "Bank and Convenience Fee",
    NOSTRO: "NOSTRO",
    VENDOR_FEE: "Vendor Fee",
    TCS: "TCS",
    TCS_TOOLTIP: "The TCS amount is indicative and may change based on your remitter selection. The final amount will be shown on the review screen before payment.",
    ADD_DECLARATION: "Add Declaration",
    YOU_PAY: "You Pay",
    THEY_RECEIVE: "They Receive",
    USER_QUOTE: "User quote",
    PROCEED: "Proceed",
  },
  QUOTE_MANAGER: {
    TITLE: "Quote Manager",
    SHARE_QUOTE: "Share quote",
    DOWNLOAD: "Download",
    MOBILE: "Mobile",
    EMAIL: "Mail",
    SEND: "Send",
    FILE_READY: "Your file is ready to be downloaded successfully.",
    DOWNLOAD_FAILED: "Download failed, please try again.",
    EMAIL_SUCCESS: "Link to download your quotation has been emailed successfully.",
    EMAIL_FAILED: "Failed to send email.",
    SMS_SUCCESS: "Quotation link sent via SMS.",
    SMS_FAILED: "Failed to send SMS.",
    FILL_VENDOR_PURPOSE: "Please fill Vendor Code and Purpose Code.",
    MOBILE_INVALID: "Phone number must be 10 digits",
    MOBILE_HINT: "Enter valid 10 digit number",
    PLACEHOLDER_EMAIL: "Enter email address",
    PLACEHOLDER_MOBILE: "Enter mobile number",
  },
  SEARCH_NAV_BAR: {
    PLACEHOLDER: "Search by Name/Number/Email",
    REMITTER_ADD_BUTTON: "Add New Remitter",
    RECIPIENT_ADD_BUTTON: "Add New Recipient",
  },
  REMITTER_SCREEN: {
    EMPTY_MSG: "No remitters found, please create a new remitter to start the transaction."
  },
  REMITTER_DETAILS: {
    KYC_LINK_SENT: "KYC Link Sent to email and phone number of the remitter",
    KYC_LINK_COPIED: "KYC Link Copied",
    KYC_LINK_NOT_COPIED: "KYC Link not Copied",
  },
  DELETE_REMITTER_MODAL: {
    TITLE: "Delete Remitter",
    DESCRIPTION: "Are you sure? Do you want to delete this remitter?"
  },
  DELETE_RECIPIENT_MODAL: {
    TITLE: "Delete Recipient",
    DESCRIPTION: "Are you sure? Do you want to delete this recipient?"
  },
  RECIPIENT_SCREEN: {
    EMPTY_MSG: "No recipient found, please create a new recipient to start the transaction."
  },
  DOCUMENTS_SCREEN: {
    RECIPIENT_DOCUMENTS: "Recipient Documents",
    BENEFICIARY_ID: "Beneficiary ID",
    RELATIONSHIP_PROOF: "Relationship proof",
    BENEFICIARY_ID_MSG: " - user can upload any identity document of the recipient. Ex - Passport, foreign driving license, etc.",
    RELATIONSHIP_PROOF_MSG: " - user can upload any government issued document that shows the relationship with the beneficiary. Ex- Passport, Marriage certificate etc."
  },
  REVIEW_SCREEN: {
    REVIEW_CALCULATION: "Review"
  },
  REMITTER_ESIGN_MODAL: {
    SIGN_A2_FORM: "Sign A2 Form",
    RECEIVE_LINK_ON: "Receive link on",
    COPY_LINK: "Copy Link",
    LINK_COPIED: "Link Copied",
    LINK_ACTIVE_FOR_5_MIN: "Received link will be active for 5 mins",
    LINK_SENT_MSG: "A link has been sent to your registered mobile number. Please draw your signature and submit the same",
    LINK_SENT_EMAIL: "A link has been sent to your registered email Id. Please draw your signature and submit the same",
    DO_IT_LATER: "Do it later",
    NOTE_DRAW_SIGNATURE: "Note- Please draw your signature as on your PAN card",
    AWAITING_SIGNATURE: "Awaiting your signature.",
    RESEND_LINK: "Resend link",
    FORM_SIGNED: "Your form has been signed",
    THANKS: "Thanks for completion!",
    DOWNLOAD_A2: "Download A2",
    GO_BACK: "Go Back",
    MOBILE: "Mobile number",
    EMAIL: "Mail",
  },
  PAYMENT_SCREEN: {
    TRANSACTION_ID_LABEL: "Transaction ID:",
    PAYABLE_AMOUNT_LABEL: "Payable Amount:",
    CURRENCY: "INR",
    SELECT_PAYMENT_METHOD: "Select your preferred payment method",
    NEFT_RTG: "NEFT / RTGS",
    SEND_PAYMENT_LINK: "Send Payment Link",
    NET_BANKING: "Net Banking",
  },
  CONFIRMATION_SCREEN: {
    TITLE: "Thank you for transacting with us!",
    PAYMENT_NOTICE_PREFIX: "Please make sure the payment of",
    PAYMENT_NOTICE_SUFFIX: "is transferred within the next 30 hours.",
    TRANSACTION_ID_LABEL: "Transaction ID",
    DASHBOARD_TEXT_PREFIX: "You can see the status of your transaction from your",
    DASHBOARD_LINK: "dashboard",
    UPLOAD_TEXT_PREFIX: "Please upload a payment confirmation screenshot displaying your name by clicking",
    UPLOAD_LINK: "here",
    SUPPORT_TEXT_PREFIX: "In Case of any query, feel free to reach out to the HOP Support at",
    SUPPORT_EMAIL: "care@moneyhop.co",
    GO_HOME: "Go Home",
  },
};